import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'i18n/config';
import 'simplebar-react/dist/simplebar.min.css';
import 'styles/index.css';
import 'styles/custom.css';
import 'styles/map-animations.css';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { PrimeReactProvider } from 'primereact/api';
import 'primereact/resources/primereact.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import initFetchInterceptor from 'utils/fetchInterceptor';

// Import theme CSS based on environment variable
const clientTheme = import.meta.env.VITE_CLIENT_THEME || 'henddu';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  },
});

// Initialize fetch interceptor early
initFetchInterceptor();

// Function to render the app
const renderApp = () => {
  ReactDOM.createRoot(document.getElementById('root')).render(
    <PrimeReactProvider>
      <QueryClientProvider client={queryClient}>
        <React.StrictMode>
          <App />
        </React.StrictMode>
        <ReactQueryDevtools />
      </QueryClientProvider>
    </PrimeReactProvider>
  );
};

// Load theme CSS before rendering to ensure CSS variables are available
import(`./styles/themes/${clientTheme}.css`)
  .then(() => {
    renderApp();
  })
  .catch(() => {
    // Fallback to henddu theme if dynamic import fails
    import('./styles/themes/henddu.css').then(() => {
      renderApp();
    });
  });
